import { ALLOWED_ICON_NAMES, navigationInstruction } from '@contember-cloud/studio-dsl';
import { emptyPrompt } from '../Prompt';
import { promptVars } from '../variables';
const icons = ALLOWED_ICON_NAMES.filter(it => !it.match(/-\d$/)).join(', ');
export const navigationPrompt = emptyPrompt
    .system(`
Your task is to create a coherent and intuitive navigation for the application, taking into account the provided list of views. The navigation you construct must be user-friendly, organized, and logically sequenced, ensuring users can easily access the application's key features and functionalities without confusion.

${navigationInstruction}

# Guidelines for Effective Navigation Design

## Navigation Structure

1.  **Relevance**: Include only views that are essential and relevant for direct user access in the navigation.
2.  **Sequence**: Organize views in a logical order that reflects the typical user workflow or application's feature hierarchy.
3.  **Clarity**: Ensure labels for navigation items are clear, concise, and descriptive to facilitate easy navigation. Don't include edit or delete actions in the main navigation.

## Best Practices

1.  **Consistency**: Use consistent naming conventions across all navigation items to reduce user confusion.
2.  **Brevity**: Opt for short, descriptive labels for navigation items to keep the interface clean and user-friendly.
3.  **Hierarchy**: Utilize a hierarchical structure for navigation to group related views together and simplify user interaction.
4.  **Accessibility**: Ensure the navigation is easily accessible and visible to users on all pages of the application.

## Special Consideration:

**Detail Views Exclusion**: Avoid directly linking to Detail views that require a unique identifier (e.g., specific product or user details) in the main navigation. Such views should be accessible through more general views where users can select specific items to view details.

# Procedure for Navigation Design

1.  **Review Views**: Examine the list of provided views to understand the application's structure.
2.  **Identify Core Views**: Select essential views that need prominent placement in the navigation based on their importance and usage frequency.
3.  **Logical Organization**: Arrange selected views in a sequence that supports user workflow and application logic.
4.  **Navigation Creation**: Utilize the syntax provided to create navigation items, ensuring labels are easily understandable.
5.  **Review for Coherence**: Examine the navigation structure for overall coherence, user-friendliness, and compliance with the guidelines.
6.  **Icon Integration**: Enhance the visual appeal of the navigation by adding icons to each navigation item.
7.  **Finalization**: Ensure the navigation design is clear, intuitive, and user-friendly before submission.

# Icons

${icons}

Your goal is to design a navigation system that offers users a seamless and intuitive way to explore the application's main features without encountering navigation dead-ends or confusion, particularly avoiding direct links to Detail views that necessitate specific identifiers.

**RESPOND ONLY WITH DSL STATEMENTS.**`)
    .human(`
# Application Specification
${promptVars.specification}

# Application Structure
${promptVars.structure}

Ensure the navigation is user-friendly, logically sequenced, and provides easy access to essential features. Include icons for each navigation item to enhance visual appeal and user experience.
`);
//# sourceMappingURL=navigationPrompt.js.map